import { Box, Skeleton } from "@mui/material";
import React from "react";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { slidingElevatedCardSx } from "../lib/appearance";

/** Placeholder matching browse {@link LibraryCard} layout while API loads. */
export default function LibraryCardSkeleton() {
    const { tokens } = useSlidingAppearance();

    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                mb: 0,
                borderRadius: "14px",
                overflow: "hidden",
                ...slidingElevatedCardSx(tokens),
            }}
            aria-hidden
        >
            <Skeleton
                variant="rectangular"
                sx={{
                    width: "100%",
                    aspectRatio: "1",
                }}
            />
            <Box sx={{ px: 1.25, py: 1.25 }}>
                <Skeleton variant="text" width="80%" height={22} sx={{ mb: 1 }} />
                <Skeleton variant="rounded" width="70%" height={24} sx={{ borderRadius: "999px", mb: 1 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Skeleton variant="circular" width={44} height={44} />
                </Box>
            </Box>
        </Box>
    );
}
